/*
 * File: /src/pages/install/install-payment-decline.vue
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 16th July 2018 2:57:21 pm
 * Last Modified: Wednesday, 29th August 2018 1:18:02 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
<template>
    <div class="install-payment-decline container" :class="`install-payment-decline--${theme}`">
        <section class="head"> 
            
            <h2 class="head__title">{{ title }}</h2>
            <p class="head__message" v-html="content"></p>
            <BaseButton @click.native="onRenew"  v-if="allowRenew" class="head__button" title="Renew payment" theme="primary"/>
        </section>
        <section class="head" v-if="status === 'pending' && charge && charge.confirmation_url">
            <p class="head__message">Some browsers can block auto redirects from Shopify App. <br/>If button above doesn't work, copy the URL below and use it manually in a new browser tab.</p>
            <pre>{{ charge.confirmation_url }}</pre>
        </section>
        <section class="foot">
            <h3 class="foot__title">Uninstalling app</h3>
            <p>To uninstall app login to your Store, go to Apps, find Airfields and click Trash button.</p>
            <p>Sorry to see you go :(</p>
        </section>
    </div>
</template>
<script>
  import { logger } from '@/helpers'
  import { mapGetters } from 'vuex'
  export default {
    data () {
        return {
            status: 'default',
            contentData: {
                declined: {
                    title: "You've declined payment",
                    content: "Please notice that there's a 7 day trial where you won't be charged.<br/>Maybe it's a good idea to give us a try?<br/><br/>You can renew your payment bellow or uninstall app.",
                    allowRenew: true,
                    theme: 'danger'
                },
                pending: {
                    title: 'Payment is pending',
                    content: 'Your payment is pending, in a few cases it can take up to two days to fully verify payment. Please try again later.',
                    allowRenew: true,
                    theme: 'default'
                },
                expired: {
                    title: 'Payment was not accepted and is expired',
                    content: 'Payment was not accepted within 2 days. You can renew your payment or uninstall app.',
                    allowRenew: true,
                    theme: 'danger'
                },
                frozen: {
                    title: 'Payment is frozen',
                    content: 'Payment is on hold due to a shop subscription non-payment. The charge will re-activate once subscription payments resume.',
                    allowRenew: false,
                    theme: 'default'
                },
                cancelled: {
                    title: 'Payment is cancelled by us',
                    content: 'Please renew the payment or contact with us at support@airfields.io.',
                    allowRenew: true,
                    theme: 'default'
                },
                default: {
                    title: '',
                    content: '',
                    allowRenew: false
                }
            }
        }
    },
    computed: {
        theme () { return this.contentData[this.status].theme },
        title () { return this.contentData[this.status].title },
        content () { return this.contentData[this.status].content },
        allowRenew () { return this.contentData[this.status].allowRenew },
        ...mapGetters('shop', ['charge'])

    },
    methods: {
        onRenew () {
            this.$router.push({name: 'install.payment'})
        }
    },
    async mounted() {
        try {
            const { status } = this.$store.getters['shop/charge']
            logger(status, 'DEV')

            this.status = status
        } catch (error) {
            console.error(`Couldn't get payment status`, error)
            this.$router.push({name: 'error'})
        }
    }
  }
</script>
<style lang="scss">
    @import './src/assets/styles/colors.scss';

    .install-payment-decline {
        text-align: center;

        p {
            font-size: 14.7px;
            line-height: 1.28;
            color: $color-pale-sky;
        }

        .head {

            &__title {
                font-size: 20px;
                font-weight: 500;
                line-height: 1.33;
            }

            &__message {
                margin-top: 30px;
            }

            &__button {
                margin-top: 30px;
            }
        }

        .foot {
            margin-top: 40px;
            padding-top: 40px;
            border-top: 1px solid $color-loblolly;

            &__title {
                font-size: 14.7px;
                line-height: 1.28;
            }

            p {
                margin-top: 20px;
            }
        }

        &--danger {
            .head__title {
                color: $color-thunderbird;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/install/install-payment-decline.vue